import { pageHeader, pageHeaderContent, pageTitle } from "../utils/styles";

export default function TitleBar() {
  return (
    <header className={pageHeader}>
      <section className={pageHeaderContent}>
        <h2 className={pageTitle}>
          Emergency Vehicle Technician Certification Commission
        </h2>
      </section>
    </header>
  );
}
